import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["mobile-filter-position"]
  static targets = ["announcement"]

  connect() {
    this.position = 0
  }

  recalculate() {
    let translate = 0

    // The AnnouncementTarget can be removed from a page
    // We need to fetch height every call
    const announcementHeight = this.hasAnnouncementTarget ? this.announcementTarget.clientHeight : 0
    const navbarHeight = this.element.clientHeight

    const newPosition = window.scrollY

    const shouldHideAnnouncement = this.hasAnnouncementTarget ? newPosition > announcementHeight : true
    const shouldHideNavbar = newPosition > navbarHeight && this.scrollDirection(newPosition) === "up"

    if (shouldHideAnnouncement) translate = announcementHeight
    if (shouldHideNavbar) translate = navbarHeight

    if (this.hasMobileFilterPositionOutlet)
      this.mobileFilterPositionOutlet.updateFilterPosition(shouldHideNavbar, announcementHeight, navbarHeight)

    // Update the mobile search popup position
    const mobileSearchModal = document.getElementById("mobile-search-modal")
    if (shouldHideAnnouncement && window.location.pathname !== "/") {
      mobileSearchModal.style.transform = `translateY(${announcementHeight}px)`
    } else {
      mobileSearchModal.style.transform = `translateY(0px)`
    }

    this.position = newPosition
    this.element.style.transform = translate ? `translateY(-${translate}px)` : "none"
  }

  // The scrollDelta could be a positive or negative number.
  // -1: scrolling down
  // +1: scrolling up
  scrollDirection(newPosition) {
    const scrollDelta = newPosition - this.position
    return scrollDelta > 0 ? "up" : "down"
  }
}
